export * from './confirm-dialog/confirm-dialog.component';
export * from './confirm-dialog-simple/confirm-dialog-simple.component';
export * from './info-dialog/info-dialog.component';
export * from './candidate-details-modal/candidate-details-modal.component';
export * from './talent-removal-dialog/talent-removal-dialog.component';